import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "ldsfdkkdlkea", // 고유한 key 값
  storage: localStorage,
});

export const userTokenState = atom({
  key: "userTokenState",
  default: null,
});

export const userSNSState = atom({
  key: "userSNSState",
  default: {
    isopen: false,
    role: "NEW",
    sns: "",
    profile: "",
    email: "",
    name: "",
    nickname: "",
    phone: "",
    accessToken: "",
    refreshToken: "",
    transfer: false,
  },
});

export const userSignUpModalState = atom({
  key: "userSignUpModalState",
  default: { isopen: false, name: "" },
});

export const dataLocalState = atom({
  key: "dsfjlkeudhsaldkja",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
